import ComponentWithSocket from '../../lib/component'
import { Component } from 'vue-property-decorator';

import template from './verify.vue';
import { ActionPayload } from 'vuex';

import * as Store from './../../store';

interface VerifyData {
    verifyState: number;
    verifyImage: any;
    verifyId: any;
    verifyImageUploaded: boolean;
    verifyIdUploaded: boolean;
    loadingVerify: boolean;
}

@Component({
    mixins: [template]
})

export default class VerifyUser extends ComponentWithSocket {

    data: VerifyData = {
        verifyState: 1,
        verifyImage: '',
        verifyId: '',
        verifyImageUploaded: false,
        verifyIdUploaded: false,
        loadingVerify: false
    }

    constructor() {
        super()
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {

        Store.commitLoaderVisibility(this.$store, false);

        this.wsListener.onPost('auth.verification', (success: boolean, data: any) => {

            if (success) {
                if ( this.$root.$options.router ) {
                    this.$root.$options.router.push('/verify-pending');
                }
                else {
                    window.location.href = '/verify-pending'
                }
            }
            else {
                alert(data)
            }

        })

    }

    doVerifyLater() {

        if ( this.$root.$options.router ) {

            if (this.$store.state.currentAuctionID) {
                this.$root.$options.router.push('/auction/' + this.$store.state.currentAuctionID);
            }
            else {
                // Go back if there is no auction id
                this.$root.$options.router.go(-1)
            }

        }

    }

    doVerifyStep(theStep: number) {

        this.data.verifyState = theStep;

    }

    previewUserImageFiles(nextStep: number) {
        let input: any = document.getElementById('verify-image'),
            $this: any = this;

        if (input.files && input.files[0]) {

            let FR = new FileReader();

            FR.addEventListener('load', function(e: any) {
                $this.data.verifyImage = e.target.result;
            });

            FR.readAsDataURL( input.files[0] );

            this.data.verifyImageUploaded = true;
            this.data.verifyState = nextStep;

        }
    }

    previewUserIdFiles(nextStep: number) {
        let input: any = document.getElementById('verify-id'),
            $this: any = this;

        if (input.files && input.files[0]) {

            let FR = new FileReader();

            FR.addEventListener('load', function(e: any) {
                $this.data.verifyId = e.target.result;
            });

            FR.readAsDataURL( input.files[0] );

            this.data.verifyIdUploaded = true;
            this.data.verifyState = nextStep;

        }
    }

    doFinalVerify(nextStep: number) {

        let $this: any = this;

        this.data.loadingVerify = true;
        this.data.verifyState   = nextStep;

        this.wsListener.sendPost('auth.verification', {
            face: $this.data.verifyImage,
            document: $this.data.verifyId
        });

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/verify/index.ts